export default __webpack_public_path__ + "static/hero_1-b4596b4cef5f2e580a963b255a1405ee.jpg";